export const CURRENT_USER = "CURRENT_USER";
export const ACCESS_TOKEN = "ACCESS_TOKEN";
export const REFRESH_TOKEN = "REFRESH_TOKEN";
export const BEHAVIOR_CLAIMS = "BEHAVIOR_CLAIMS";
export const ADMIN_REFRESH_TOKEN = "ADMIN_REFRESH_TOKEN";
export const ADMIN_ACCESS_TOKEN = "ADMIN_ACCESS_TOKEN";
export const ADMIN_RETURN_URL = "ADMIN_RETURN_URL";
export const ADMIN_OVERRIDE_DASHBOARD_REDIRECT = "ADMIN_OVERRIDE_DASHBOARD_REDIRECT";